import { c as _c } from "react/compiler-runtime";
import React from 'react';
function fallbackMatchMedia(query) {
  if (typeof matchMedia !== 'function') {
    return null;
  }
  return matchMedia(query);
}
function omitMatchMediaResult(matchMediaResult) {
  if (!matchMediaResult) {
    return null;
  }
  return {
    media: matchMediaResult.media,
    matches: matchMediaResult.matches
  };
}
export function useMedia(query, t0) {
  const $ = _c(8);
  const hydrationSafe = t0 === undefined ? true : t0;
  const [mounted, setMounted] = React.useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function () {
      setMounted(true);
    };
    t2 = [setMounted];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  React.useEffect(t1, t2);
  let t3;
  if ($[2] !== query) {
    t3 = function () {
      return omitMatchMediaResult(fallbackMatchMedia(query));
    };
    $[2] = query;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [result, setResult] = React.useState(t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = function (matchMediaResult) {
      return setResult(omitMatchMediaResult(matchMediaResult));
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const callback = t4;
  let t5;
  let t6;
  if ($[5] !== query) {
    t5 = function () {
      const matchMediaResult_0 = fallbackMatchMedia(query);
      callback(matchMediaResult_0);
      if (matchMediaResult_0) {
        matchMediaResult_0.addEventListener("change", callback);
      }
      return function () {
        if (matchMediaResult_0) {
          matchMediaResult_0.removeEventListener("change", callback);
        }
      };
    };
    t6 = [callback, query];
    $[5] = query;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  React.useEffect(t5, t6);
  if (hydrationSafe && !mounted) {
    return null;
  }
  return result;
}
export function useMediaPredicate(query, t0) {
  const hydrationSafe = t0 === undefined ? true : t0;
  const result = useMedia(query, hydrationSafe);
  return result && result.matches || false;
}